var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.725 11.1489L23.7242 11.148L18.8256 6.273C18.4586 5.90779 17.865 5.90915 17.4997 6.27618C17.1344 6.64317 17.1359 7.23675 17.5028 7.602L20.7918 10.875H0.9375C0.419719 10.875 0 11.2947 0 11.8125C0 12.3303 0.419719 12.75 0.9375 12.75H20.7917L17.5029 16.023C17.1359 16.3882 17.1345 16.9818 17.4997 17.3488C17.865 17.7159 18.4587 17.7171 18.8256 17.352L23.7242 12.477L23.7251 12.4761C24.0922 12.1096 24.0911 11.5141 23.725 11.1489Z",
    fill: "#332F21"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e3aa87e268c60bd29789394bcea9a1a2.svg";
export { ForwardRef as ReactComponent };